<template>
	<page>
		<module enable-flex>
			<c-tab-list ref="tabList" :tabs="tabList" type="border-tab" @change="tableHandle"></c-tab-list>
			<m-search v-if="currentTabValue == 2" ref="search" key="tree" :default-data="{'is_product_bom': [1]}" @search="searchHandle">
				<m-search-item label="产品编号">
					<c-input name="product_code"></c-input>
				</m-search-item>
				<m-search-item label="产品名称">
					<c-input name="product_name"></c-input>
				</m-search-item>
				<m-search-item label="产品规格">
					<c-input name="product_spec"></c-input>
				</m-search-item>
				<m-search-item>
					<c-checkbox-group name="is_product_bom">
						<c-checkbox value="1">仅查询已配置BOM的产品</c-checkbox>
					</c-checkbox-group>
				</m-search-item>
			</m-search>

			<m-search v-else ref="search" key="list" @search="searchHandle">
				<m-search-item label="父项产品编号">
					<c-input name="parent_product_code"></c-input>
				</m-search-item>
				<m-search-item label="父项产品名称">
					<c-input name="parent_product_name"></c-input>
				</m-search-item>
				<m-search-item label="父项产品规格">
					<c-input name="parent_product_spec"></c-input>
				</m-search-item>
				<m-search-item label="子项产品编号">
					<c-input name="product_code"></c-input>
				</m-search-item>
				<m-search-item label="子项产品名称">
					<c-input name="product_name"></c-input>
				</m-search-item>
				<m-search-item label="子项产品规格">
					<c-input name="product_spec"></c-input>
				</m-search-item>
				<m-search-item label="投料工序">
					<c-input name="process_name"></c-input>
				</m-search-item>
				<m-search-item label="备注">
					<c-input name="remark"></c-input>
				</m-search-item>
			</m-search>

			<m-operate :batch="batchData.length" @batchCancel="batchCancel">
				<c-button color="main" v-if="auth('b_material_edit')" v-lock="lock('b_material_edit')" prepend-icon="tf-add" @click="$refs.materialEdit.open(null,true)">创建物料清单</c-button>
				<c-button v-if="auth('b_material_export') && currentTabValue == 1" v-lock="lock('b_material_export')" prepend-icon="tf-export" @click="exportListByViewId()">导出</c-button>
				<c-button v-if="auth('b_material_export') && currentTabValue == 1" v-lock="lock('b_material_export')" prepend-icon="tf-export" @click="exportListByViewId(3)">按模板导出</c-button>
				<c-button v-if="auth('b_material_edit')" v-lock="lock('b_material_edit')" prepend-icon="tf-import" @click="excelImport()">导入</c-button>
				
				<template #batch>
					<c-button v-if="auth('b_material_export') && currentTabValue == 1" v-lock="lock('b_material_export')" prepend-icon="tf-export" @click="exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_material_export') && currentTabValue == 1" v-lock="lock('b_material_export')" prepend-icon="tf-export" @click="exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #right>
					<c-button v-if="auth('b_material_log')" v-lock="lock('b_material_log')" prepend-icon="tf-import-record" @click="loadImportLogDetail()">导入记录</c-button>
				</template>
			</m-operate>

			<c-table ref="list" height="grow" width-resize>
				<template v-if="currentTabValue == 2">
					<c-table-column
						key="tree"
						type="tree"
						label="产品编号"
						width="240"
						name="childProduct"
						:leaf-node="({data}) => !data.childProduct"
					>
						<template #default="{data}">
							{{data.product_code}}
						</template>
					</c-table-column>
					<c-table-column label="产品名称" name="product_name" width="250" :ellipsis="false"></c-table-column>
					<c-table-column label="产品规格" name="product_spec" width="100"></c-table-column>
					<c-table-column label="库存数量" name="product_count" width="100"></c-table-column>
					<c-table-column label="单位" name="unit" width="80"></c-table-column>
				</template>

				<template v-else>
					<c-table-column type="selector" width="32" @handle="batchSelect"></c-table-column>
					<c-table-column label="父项产品编号" name="parent_product_code" width="100"></c-table-column>
					<c-table-column label="父项产品名称" name="parent_product_name" width="200" :ellipsis="false"></c-table-column>
					<c-table-column label="父项产品规格" name="parent_product_spec" width="100"></c-table-column>
					<c-table-column label="父项库存数量" name="parent_product_count" width="100"></c-table-column>
					<c-table-column label="父项单位" name="parent_unit" width="80"></c-table-column>
					<c-table-column label="子项产品编号" name="product_code" width="100"></c-table-column>
					<c-table-column label="子项产品名称" name="product_name" width="200" :ellipsis="false"></c-table-column>
					<c-table-column label="子项产品规格" name="product_spec" width="100"></c-table-column>
					<c-table-column label="子项库存数量" name="product_count" width="100"></c-table-column>
					<c-table-column label="子项单位" name="unit" width="80"></c-table-column>
				</template>

				<c-table-column label="单位用量" name="unit_count" width="80"></c-table-column>
				<c-table-column label="投料工序" name="process_name" width="150">
					<template #default="{data}">
						<span v-if="data.process_name">{{data.process_name}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>
				<c-table-column label="备注" name="remark" width="150">
					<template #default="{data}">
						<span v-if="data.remark">{{data.remark}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>
				<c-table-column label="创建人" name="create_user_realname" width="150">
					<template #default="{data}">
						<span v-if="data.is_manage == 1">-</span>
						<span v-else>{{data.create_user_realname}}</span>
					</template>
				</c-table-column>
				<c-table-column label="创建时间" name="create_date" width="140"></c-table-column>
				<c-table-column type="button" label="操作" width="110">
					<template #default="{data}">
						<c-table-button v-if="auth('b_material_edit')" v-lock="lock('b_material_edit')" icon="tf-edit" @click="$refs.materialEdit.open({parent_product_id: currentTabValue == 1 ? data.parent_product_id : data.product_id})">编辑</c-table-button>
						<c-table-button v-if="auth('b_material_edit')" v-lock="lock('b_material_edit')" :disabled="!(data.id)" icon="tf-trash" @click="removeMaterial(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--新增/编辑物料弹窗-->
			<material-edit ref="materialEdit"  @resolve="$refs.list.update()"></material-edit>
		</module>
	</page>
</template>

<script>
import materialEdit from "@/pages/basic/product_material_edit.vue";
import {batchData, batchMethods} from '@/components/public/batch.js'

export default {
	components: {materialEdit},

	data() {
		return {
			...batchData(),
			tabList: [{
				name: '按树形查看',
				value: 2
			}, {
				name: '按表格查看',
				value: 1
			}],
			currentTabValue: 2,
			viewId:10009,      //固定视图ID
			workType:15,       //业务类型
			flterParams:{}
		}
	},

	methods: {
		...batchMethods(),

		tableHandle(tab) {
			this.batchCancel();
			this.currentTabValue = tab.value;
			this.$refs.list.setData([]);
			this.$nextTick(() => {
				this.$refs.search.clear();
				this.$refs.search.search();
			});
		},
		/********搜索************/
		searchHandle(data) {
			this.$refs.list.load({
				url: this.currentTabValue == 2 ? '/product/children/tree' : '/product/material/list',
				data,
				success: () => {
					this.batchData = [];
				}
			});
			this.flterParams = data;
		},
		/**
		 * 通过视图ID导出数据
		 */
		exportListByViewId(export_type){
			var selectedRows = this.$refs.list.getRow('selected');
			var ids = [];//选中的数据行
			if (selectedRows && selectedRows.length > 0){
				ids = selectedRows.map(item => item.data.id);
			}
			this.flterParams.view_id = this.viewId;
			this.flterParams.ids = ids;//选中的数据行ID
			this.flterParams.export_type = export_type||1;//导出数据类型 1=按照视图导出列表  2=-详情  3、按模板导出列表
			if (export_type && export_type==3){
				this.exportByTemplate(export_type);
			}else {
				this.request({
					url: '/export/url',
					data: this.flterParams,
					success: data => {
						this.download({
							fileName: data.filename,
							url: data.url,
							loading: {
								message: '数据文件生成中...'
							}
						})
					}
				});
			}
		},

		// 导出数据
		exportByTemplate(templateType) {
			this.globalDialog('exportTemplateSelector',{
				props: {
					workType: this.workType,
					templateType: templateType || 2
				},
				data: {
					excelParams: this.flterParams
				}
			});
		},

		/******删除物料清单***********/
		removeMaterial(data){
			this.$confirm({
				message:'确认删除物料？删除后不可恢复',  // 提示内容,
				buttonName: '确定',  // 确定按钮文字
				cancelButton: true,  // 是否显示取消按钮
				resolve: () => {
					this.request({
						url: '/product/children/remove',
						data: {id:data.id},
						loading: true,
						success: data => {
							this.$message({
								message:'删除成功',  // 提示内容,
								type: 'success'
							});
							this.$refs.list.update();
						}
					});
				},  // 确定按钮回调
				cancel: () => {},  // 取消按钮回调
			});
		},

		/******导入Excel数据**********/
		excelImport(){
			//打开模板选择弹窗
			this.globalDialog('excelImport',{
				props: {
					workType: this.workType
				}
			},this.importHandle);
		},

		/*********导入成功回调****************/
		importHandle(){
			setTimeout(() => {
				this.$refs.list.update();
			}, 300);
		},

		/******加载导入业务日志列表**********/
		loadImportLogDetail(){
			//打开模板选择弹窗
			this.globalDialog('importLogDetail',{
				props: {
					workType: this.workType
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>